import { getAllEntities } from "../../services/entitiesService";

const schema = async () => {
  const s = {
    type: "object",
    properties: {
      entity: {
        type: "string",
      },
    },
    required: ["entity"],
  };

  const res = await getAllEntities();

  s.properties.entity.oneOf = res.data.map((r) => ({
    const: { id: r.id, name: r.name },
    title: r.name,
  }));

  return {
    schema: s,
  };
};

export default schema;
